"use client";

import Carousel from "@/components/common/Carousel";
import FlightDealItem from "./FlightDealItem";
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth";
import { useEffect, useRef, useState } from "react";

interface FlightDealsDesktopProps {
  flights: any[];
  loading: boolean;
  origin: string
  singleSlide?: boolean
  autoPlay?: number | false
  minWidth?: number
  maxWidth?: number
}

const FlightDealsDesktop = ({
  flights,
  origin,
  singleSlide = false,
  autoPlay = false,
  minWidth,
  maxWidth,
}: FlightDealsDesktopProps) => {
  const devicePassedWidth = useDevicePassedWidth(
    (screenWidth) => screenWidth
  );
  const initLoaded = useRef<any>({})
  const [shown, setShown] = useState<any>(-1)
  const flickityInstance = useRef<any>(undefined)

  useEffect(() => {
    if (!devicePassedWidth) return;
    if (singleSlide) {
      setShown(devicePassedWidth <= (maxWidth ?? 991))
      return
    }
    if (!!initLoaded.current[devicePassedWidth]) return;
    initLoaded.current = {
      [devicePassedWidth]: true
    }
    setShown(devicePassedWidth >= (minWidth ?? 577))
  }, [devicePassedWidth, singleSlide, minWidth, maxWidth])

  useEffect(() => {
    if (singleSlide) return;
    return () => {
      initLoaded.current = {}
    }
  }, [singleSlide])

  // Flickity đo width lúc container còn display:none nên có thể tính sai kích thước cell.
  // Cần resize lại đúng lúc container thực sự hiện ra (shown chuyển sang true).
  useEffect(() => {
    if (shown === true) {
      flickityInstance.current?.resize()
    }
  }, [shown])

  if (!shown) {
    return <></>;
  }

  const filteredFlights = flights.filter(f => !origin ? true : f.productMetaData?.startPoint === origin)
  const isMultiSlide = filteredFlights.length > 1
  const isInternational = filteredFlights[0]?.productMetaData?.flightType === "INTERNATIONAL"

  return (
    <Carousel
      className={`carousel-main home__deals-flights--list home__deals-flights--list-poster${isInternational ? " home__deals-flights--list-international" : ""}${singleSlide ? " home__deals-flights--list-single" : ""}${!singleSlide && minWidth === 992 ? " home__deals-flights--list-wide" : ""}`}
      flickityRef={(flickity) => { flickityInstance.current = flickity }}
      options={singleSlide ? {
        pageDots: false,
        cellAlign: "left",
        contain: true,
        draggable: isMultiSlide,
        prevNextButtons: isMultiSlide,
        wrapAround: false,
        groupCells: false,
        percentPosition: true,
        autoPlay: isMultiSlide ? (autoPlay || 3000) : false,
        pauseAutoPlayOnHover: true,
      } : {
        pageDots: false,
        cellAlign: "left",
        draggable: true,
        prevNextButtons: true,
        contain: true,
        groupCells: true
      }}
      style={shown === -1 ? { display: 'none' } : {}}
    >
      {filteredFlights.map((flight) => (
        <div
          key={flight.id}
          className="flickity-container flickity-cell"
        >
          <FlightDealItem
            deal={flight}
            variant={flight.productMetaData?.flightType === "INTERNATIONAL" ? "international" : "good-price"}
          />
        </div>
      ))}
    </Carousel>
  );
};

export default FlightDealsDesktop;
